module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("sitepage_billingcontact", [["div",{"class":"content-block pad-lr pad-tb","id":"account-form"},[["div",{"class":"global-title"},[["textNode",{"text":"Contact billing support"}]]],["div",{"class":"verifiedcall-wrapper billing-support-page pad-tb"},[["p",{"class":"description"},[["textNode",{"text":"Address your questions to billing support team:"}]]],["div",{"class":"contact-form-wrapper"}]]]]]]);
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-dynamic-injection!/var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-template-loader?interpolate!./templates/sitepage/billingContact.tpl
// module id = 1189
// module chunks = 4